import React from 'react';

import { useTranslation } from '@common/hooks/translation';
import { POPUPS } from '@common/constants/popups';
import Config from '@app/dev/config/main';

export const SuccessReset = ({ closePopup, openPopup }) => {
  const t = useTranslation();

  const signInTypesEnum = {
    cpf: {
      callback: () => openPopup(POPUPS.SIGN_IN),
      type: 'cpf',
    },
    email: {
      callback: () => openPopup(POPUPS.LOGIN_FORM, { signInToAdmin: false, popupPosition: 'top' }),
      type: 'email',
    },
  };

  const signInCallback = signInTypesEnum[Config.main.signInType]?.callback;

  return (
    <div className="popup-content popup-small">
      <div className="popup-main-content">
        <div className="title-row">
          <p className="title-row-text">
            {t('Congratulations')}
            !
          </p>
        </div>
        <div className="main-middle-row">
          <div className="container-for-icon">
            <i className="global-icon icon-checkmark main-middle-icon" />
          </div>
        </div>
        <div className="central-text-row">
          <p className="central-text">{t('PIN Code was successfully changed')}</p>
        </div>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={closePopup}
          className="popup-cancel-button"
        >
          {t('Close')}
        </button>

        <button
          type="button"
          onClick={signInCallback}
          className="popup-confirm-button"
        >
          {t('Sign In')}
        </button>
      </div>
    </div>
  );
};
